'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Popover as PopoverPrimitive } from 'radix-ui';
import { cn } from '../../../lib/utils.js';
function Popover(_a) {
    var props = __rest(_a, []);
    return <PopoverPrimitive.Root data-slot="popover" {...props}/>;
}
function PopoverTrigger(_a) {
    var props = __rest(_a, []);
    return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props}/>;
}
function PopoverContent(_a) {
    var className = _a.className, _b = _a.align, align = _b === void 0 ? 'center' : _b, _c = _a.sideOffset, sideOffset = _c === void 0 ? 4 : _c, props = __rest(_a, ["className", "align", "sideOffset"]);
    return (<PopoverPrimitive.Portal>
      <PopoverPrimitive.Content data-slot="popover-content" align={align} sideOffset={sideOffset} className={cn('bg-popover text-popover-foreground ring-foreground/10 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95 z-50 flex w-72 origin-(--radix-popover-content-transform-origin) flex-col gap-2.5 rounded-lg p-2.5 text-sm shadow-md ring-1 outline-hidden duration-100', className)} {...props}/>
    </PopoverPrimitive.Portal>);
}
function PopoverAnchor(_a) {
    var props = __rest(_a, []);
    return <PopoverPrimitive.Anchor data-slot="popover-anchor" {...props}/>;
}
function PopoverHeader(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (<div data-slot="popover-header" className={cn('flex flex-col gap-0.5 text-sm', className)} {...props}/>);
}
function PopoverTitle(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (<div data-slot="popover-title" className={cn('cn-font-heading font-medium', className)} {...props}/>);
}
function PopoverDescription(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (<p data-slot="popover-description" className={cn('text-muted-foreground', className)} {...props}/>);
}
export { Popover, PopoverAnchor, PopoverContent, PopoverDescription, PopoverHeader, PopoverTitle, PopoverTrigger, };
